import { render, staticRenderFns } from "./Site.vue?vue&type=template&id=24f29224&"
import script from "./Site.vue?vue&type=script&lang=js&"
export * from "./Site.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jogg/jogg-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24f29224')) {
      api.createRecord('24f29224', component.options)
    } else {
      api.reload('24f29224', component.options)
    }
    module.hot.accept("./Site.vue?vue&type=template&id=24f29224&", function () {
      api.rerender('24f29224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/Site.vue"
export default component.exports